<template>
  <div id="contact-header" class="text-center max-w-lg mx-auto">
    <h2 id="contact-title"
        class="text-center text-3xl leading-tight font-extrabold tracking-tight text-white sm:text-4xl">
      Soovid personaalset lahendust?
    </h2>
    <p id="contact-description"
       class="mt-2 font-normal max-w-md lg:max-w-2xl mx-auto text-center text-base md:text-lg xxl:text-xl leading-relaxed tracking-normal text-white">
      Võtke meiega ühendust. Aitame välja mõelda Teie soovidele ja nägemusele vastava kodulehe.
    </p>
  </div>
</template>

<script>
import {gsap} from 'gsap'

export default {
  name: "ContactHeader",
  methods: {
    animationsInit() {
      const scroller = this.$parent.$parent.$refs['scrollSections'];
      const trigger = '#contact-header'
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger,
          scroller,
          start: 'top 95%',
          end: 'bottom 25%'
        },
        defaults: {
          y: 0,
          opacity: 1,
          ease: 'slow',
          autoAlpha: 1
        }
      })
      tl.to('#contact-title', {})
      tl.to('#contact-description', {}, 0.3)
    }
  },
  mounted() {
    this.$nextTick(() => {
      const elements = gsap.utils.toArray('#contact-title, #contact-description')
      elements.forEach(element => {
        gsap.set(element, {
          y: 100,
          opacity: 0,
          autoAlpha: 0
        })
      })
      this.animationsInit()
    })
  }
}
</script>

<style scoped>

</style>
